export function isEveryFieldDefined(fields) {
    return Object.values(fields).every((value) => value !== undefined);
}
